import { render, staticRenderFns } from "./RowImage.vue?vue&type=template&id=0b61eff0&scoped=true&"
import script from "./RowImage.vue?vue&type=script&lang=js&"
export * from "./RowImage.vue?vue&type=script&lang=js&"
import style0 from "./RowImage.vue?vue&type=style&index=0&id=0b61eff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61eff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/www/word-trainer-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VImg,VTooltip})
